AFRAME.registerComponent('object-to-aframe-observer', {
  schema: {
    targetComponent: { type: 'string', default: '' } // This will specify which component to apply changes to
  },

  init: function () {
    this.model = this.el.object3D;

    if (!this.model) {
      console.warn('No object3D found in the entity');
      return;
    }

    // Observe all passed properties (dynamic from mediaOptions and parent)
    this._observeModelProperties();
  },

  // Function to dynamically define getters/setters for passed properties
  _observeModelProperties: function () {
    const model = this.model;
    const passedProps = this.data;

    // Iterate over all passed properties and observe them
    for (let prop in passedProps) {
      if (passedProps.hasOwnProperty(prop) && prop !== 'targetComponent') {
        this._defineDynamicProperty(model, prop);
      }
    }
  },

  // Helper function to define getter/setter for any passed property
  _defineDynamicProperty: function (model, prop) {
    Object.defineProperty(model, prop, {
      get: () => {
        return this.data[prop];
      },
      set: (value) => {
        this.data[prop] = value;

        // Retrieve the target component dynamically
        const targetComponent = this.data.targetComponent || 'media-loader';

        // Handle the exception for "src"
        if (prop === 'src') {
          this.el.setAttribute(targetComponent, { src: value });
        } else {
          // For all other properties, pass them as mediaOptions
          const { src, ...otherProps } = this.data;
          const mediaOptions = { ...otherProps };
          this.el.setAttribute(targetComponent, { mediaOptions });
        }
      },
    });
  },

  update: function () {
    this.model = this.el.object3D;
    if (!this.model) {
      return;
    }

    // Reapply all properties dynamically
    for (let prop in this.data) {
      if (this.data.hasOwnProperty(prop) && prop !== 'targetComponent') {
        this.model[prop] = this.data[prop]; // Triggers the setter
      }
    }
  }
});